import { Grid, IconButton, Pagination, Skeleton, Stack, Tab, Tabs, TextField } from '@mui/material';
import CourseCard from './components/CourseCard';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { TAB_STYLE, TABS } from './course_creation/utils/constaints';
import { useDispatch } from 'react-redux';
import { getCourseCards } from '../../redux/features/courseSlice';
import { useSelector } from 'react-redux';
import AddCourse from './course_creation/AddCourse';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { getProjects } from '../../redux/features/refundSlice';
import GlobalSelectFieldWithoutFormik from '../../components/mui/GlobalSelectFieldWithoutFormik';
import NoDataFound from '../../components/NodataIndication/NoDataFound';

export default function AcadamicsView() {
  const [tab, setTab] = useState(null);
  const [project, setProject] = useState({
    id: 0,
    value: '',
  });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState({
    search: '',
    change: false,
  });

  const [openAddCourse, setOpenAddCourse] = useState(false);

  const dispatch = useDispatch();
  const courseCard = useSelector((state) => state.course.courseCard.data);
  const courseCardLoadign = useSelector((state) => state.course.courseCard.loading);
  const projectslist = useSelector((state) => state.refund.projectslist);
  const meta = useSelector((state) => state.course.courseCard.meta);

  const dispatchParams = useMemo(
    () => ({
      course_type: tab,
      limit: 12,
      page,
      search: search?.search,
      project_id: project?.id === 0 ? null : project?.id,
    }),
    [tab, page, search?.change, project],
  );

  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCourseCards(dispatchParams));
  }, [dispatch, dispatchParams]);

  return (
    <Stack gap={3} mt={5} width={'100%'}>
      <AddCourse
        open={Boolean(openAddCourse)}
        setOpen={setOpenAddCourse}
        row={openAddCourse}
        successDispatchFn={getCourseCards}
        successDispatchParams={dispatchParams}
      />
      <Tabs
        onChange={(_, v) => setTab(v)}
        sx={{
          display: 'flex',
          width: '100%',
        }}
        variant="fullWidth"
        value={tab}
        TabIndicatorProps={{
          sx: {
            bgcolor: 'black',
          },
        }}
      >
        {TABS.map(({ id, value, label }) => (
          <Tab key={id} value={value} label={label} sx={TAB_STYLE} />
        ))}
      </Tabs>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} gap={2}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSearch((prev) => ({ ...prev, change: !prev.change }));
          }}
        >
          <TextField
            sx={{ width: { sm: 350, xs: '100%' } }}
            fullWidth
            value={search.search}
            onChange={(e) => setSearch((prev) => ({ ...prev, search: e.target.value }))}
            label="Search"
            InputProps={{
              sx: { borderRadius: 5 },
              endAdornment: (
                <Stack direction="row">
                  {Boolean(search.search) && (
                    <IconButton
                      onClick={() =>
                        setSearch((prev) => ({
                          ...prev,
                          search: '',
                          change: !prev.change,
                        }))
                      }
                    >
                      <ClearOutlinedIcon />
                    </IconButton>
                  )}

                  <IconButton type="submit">
                    <SearchOutlinedIcon />
                  </IconButton>
                </Stack>
              ),
            }}
          />
        </form>
        <GlobalSelectFieldWithoutFormik
          data={projectslist}
          label={'Project'}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          selectedDetails={project}
          setChange={setProject}
          sx={{
            minWidth: { xs: '100%', sm: 200 },
          }}
        />
      </Stack>
      <Grid container spacing={2}>
        {courseCardLoadign ? (
          Array.from({ length: 12 }).map((item, i) => (
            <Grid key={i} item xl={3} md={4} sm={6} xs={12}>
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 400,
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              />
            </Grid>
          ))
        ) : courseCard?.length ? (
          courseCard.map((e, i) => (
            <Grid item xl={3} md={4} sm={6} xs={12} key={i}>
              <Link to={e?.course_available_detail_id ? `${e.course_available_detail_id}` : '#'}>
                <CourseCard
                  isDiscriptionAdded={Boolean(e?.course_available_detail_id)}
                  title={e?.title ?? e?.course_name}
                  project={e?.project_name}
                  status={Boolean(e?.course_availability)}
                  key={i}
                  age={`${e?.age_from}-${e?.age_to}`}
                  img={e?.imageSrc}
                  setOpenAddCourse={setOpenAddCourse}
                  row={e}
                />
              </Link>
            </Grid>
          ))
        ) : (
          <Stack justifyContent={'center'} alignItems={'center'} width={'100%'}>
            <NoDataFound />
          </Stack>
        )}
      </Grid>
      <Pagination
        count={meta?.totalPages}
        variant="outlined"
        onChange={(_, v) => setPage(v)}
        sx={{
          alignSelf: 'flex-end',
        }}
      />
    </Stack>
  );
}
